export interface SmsUsageSummaryPayloadModel {
  sent: number;
  error: number;
  creditUsed: number;
}
